import { render, staticRenderFns } from "./repairDispatchManageList.vue?vue&type=template&id=65c580fe&scoped=true"
import script from "./repairDispatchManageList.vue?vue&type=script&lang=js"
export * from "./repairDispatchManageList.vue?vue&type=script&lang=js"
import style0 from "./repairDispatchManageList.vue?vue&type=style&index=0&id=65c580fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c580fe",
  null
  
)

export default component.exports